//DEPENDENCIES
import React from 'react';
// CORE COMPONENT
import Form from 'core/form/Form';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { SETTINGS } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions';

// GLOBAL HELPERS
import { getListData } from 'helpers/getListData';

// PARTS
import Main from 'parts/main/Main';
import Table from 'parts/table/Table';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { COLUMNS } from 'columns';

// LOCAL COMPONENTS
import SelectFiles from './dynamicForms/parts/SelectFiles';
import Upload from './dynamicForms/parts/Upload';
import ViewFileCell from './dynamicForms/parts/ViewFileCell';

// MAIN COMPONENT
const DynamicForms = () => (
  <Form className="w-100">
    <Main>
      <Title title="Dynamic Forms" />
      <Table mobilePreviewKeys={['form_title', 'date_updated']} />
    </Main>
  </Form>
);

// EXPORT
export default getListData(DynamicForms, {
  key: 'dynamicForms',
  path: makePath(SETTINGS.dynamicForms),
  fetchArgs: {
    endpoint: ENDPOINTS.admin.adminForm.list
  },
  columns: [
    {
      key: 'form_title',
      label: 'Title',
      width: 200
    },
    {
      key: 'form_filename',
      label: 'Link',
      component: ViewFileCell
    },
    COLUMNS.updatedOn,
    {
      key: 'selectedFile',
      label: 'Select File',
      component: SelectFiles
    },
    {
      key: 'dsl_form_id',
      label: 'Function',
      component: Upload
    }
  ]
});
